import React, { useMemo, useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import rolesList from 'const/rolesList'
import withLeftSidebar from 'components/Sidebar/withLeftSidebar'
import useChannel from 'hooks/useChannel'
import {
  LeftSidebarView,
} from 'components/Sidebar'
import Loader from 'components/Loader'
import User from 'components/ControlledUser'
import KanBoIcon from 'components/KanBoIcon'
import UserRoles from '../UserRoles'

export function UsersByRole ({
  roleId,

  users,

  fetchUsersByRole,
  requestRemoveUserRole,

  leftSidebar,
}) {
  useChannel('userRoles')

  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    fetchUsersByRole({
      role: roleId,
      onEnd: () => {
        setIsLoading(false)
      }
    })
  }, [roleId, fetchUsersByRole])

  const role = useMemo(() => rolesList.find(role => role.id === roleId), [roleId])

  return (
    <LeftSidebarView
      title={
        <FormattedMessage
          id='USERS_BY_ROLE_HEADER'
          values={{
            roleName: <FormattedMessage id={role.formattedMessageId} />
          }}
        />
      }
    >
      {isLoading
        ? <Loader center />
        : (
          users.map(userId =>
            <User
              listItem
              presence
              defaultMenu
              key={userId}
              id={userId}
              menu={[{
                icon: <KanBoIcon fixedWidth name='kanbo-16-remove' />,
                title: <FormattedMessage id='USERS_BY_ROLE_REMOVE_USER' />,
                onClick: () => {
                  requestRemoveUserRole({
                    userId,
                    role: role.id,
                  })
                }
              }]}
              onClick={() => {
                leftSidebar.push(() => <UserRoles userId={userId} />)
              }}
            />
          )
        )
      }
    </LeftSidebarView>
  )
}

export default withLeftSidebar(UsersByRole)
